













import {Component, Vue} from 'vue-property-decorator';
import ReportContainer from '../../components/report-container/report-container.vue';
import FilterContainer from '../../components/filter-container/filter-container.vue';
import NearestReportsFilter from '@/modules/neodash/pages/nearestReports/nearest-reports-filter.vue';
import {FormFilterFields} from '@/modules/neodash/model/types/interfaces/FormFilterFields';
import ReportVueContainer from '@/modules/neodash/components/report-vue-container/report-vue-container.vue';
import NearestListReports from '@/modules/neodash/pages/nearestReports/nearest-list-reports.vue';
import {TypeRequestReportRouteEnum} from '@/modules/neodash/pages/nearestReports/types';

@Component({
  name: 'NearestReports',
  components: {NearestListReports, NearestReportsFilter, FilterContainer, ReportContainer, ReportVueContainer}
})
export default class NearestReports extends Vue {
  public readonly keyLabelListNearestReports: string = 'Report.Nearest_Report';

  public filters: FormFilterFields<TypeRequestReportRouteEnum> = {
    value: 0 as TypeRequestReportRouteEnum,
    labels: []
  } as FormFilterFields<TypeRequestReportRouteEnum>;

  public get shouldShowReport(): boolean {
    return !!this.filters.value;
  }
}
